// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__20Kg-","messages":"Chat_messages__2-xam","dateDivider":"Chat_dateDivider__19UhE"};